// import Assignment from './Assignment';

export default {
  priority: 10,
  // component: Assignment,
  component: load(() => import(/* webpackChunkName: "Requests-Pattern-Assignment" */ './Assignment')),
  name: app.translate('routes.home.requests.Assignment'),
  path: 'assignment',
  permissions: ['RequestsMenu/RequestPattern/PatternAssignmentMenu'],
  icon: 'account-check',
  drawer: true,
};


